import { useRef } from "react";
import Editor from "@monaco-editor/react";
const GrtCodeEditor = function (props) {
    const editorRef = useRef(null);
    function handleEditorDidMount(editor, monaco) {
        editorRef.current = editor;
    }
    return (<Editor value={props.defaultValue} height={props.height + "vh"} v2="true" theme={props.theme} language={props.language} onValidate={props.onValidate} onChange={props.onChange} onMount={handleEditorDidMount}/>);
};
export default GrtCodeEditor;
